import { useEffect, useState } from "react";
import FundraiserHeader from "../../components/ImprovedShopPage/FundraiserHeader";
import Shop from "../../components/ImprovedShopPage/Shop";
import { FundraiserProvider } from "./FundraiserContext";
import "./styles/custom.css";
import { createTheme, ThemeProvider } from "@mui/material";
import Donation from "../../components/ImprovedShopPage/Donation";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import config from "../../config";
import { useParams } from "react-router-dom";
import { parseParticipantID } from "../../CommonFunctions";
import calculateTimeLeft from "../../components/ImprovedShopPage/CalculateTimeLeft";
import FundraiserExpired from "../../components/ImprovedShopPage/ShopTimeExpired";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0C5D53",
      // light: primaryColor[300],
      // dark: primaryColor[700],
      contrastText: "#fff",
    },
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#0C5D53",
          // light: primaryColor[300],
          // dark: primaryColor[700],
          contrastText: "#fff",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#0C5D53",
          // light: primaryColor[300],
          // dark: primaryColor[700],
          contrastText: "#fff",
        },
      },
    },
  },
});

const ImprovedShopPage = () => {
  const [participantShop, setParticipantShop] =
    useState<ImprovedParticipantShop>();
  const { participantID } = useParams();
  const decryptedParticipantID = parseParticipantID(
    participantID || "ffffffffff",
  );
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const isTimeOver = (): boolean => {
    return (
      timeLeft.days === 0 &&
      timeLeft.hours === 0 &&
      timeLeft.minutes === 0 &&
      timeLeft.seconds === 0
    );
  };

  useEffect(() => {
    const fetchParticipantShop = async () => {
      const response = await fetch(
        `${config.API_BASE_URL}fundraiser-shop/${decryptedParticipantID}/`,
      );
      const participantShop = await response.json();
      if (response.ok) {
        setParticipantShop(participantShop);
      }
    };

    fetchParticipantShop();
    document.title = "Participant Shop";
  }, []);

  useEffect(() => {
    if (!participantShop?.fundraiser.end_date) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(participantShop.fundraiser.end_date));
    }, 1000);

    return () => clearInterval(timer);
  }, [participantShop?.fundraiser.end_date]);
  if (!participantShop) return null;

  return (
    <div className="main">
      <ThemeProvider theme={theme}>
        <FundraiserProvider>
          <>
            <FundraiserHeader
              participantShop={participantShop}
              timeLeft={timeLeft}
            />
            {isTimeOver() ? (
              <FundraiserExpired />
            ) : (
              <>
                <Shop participantShop={participantShop} />
                <Donation participantShop={participantShop} />
              </>
            )}
          </>
        </FundraiserProvider>
      </ThemeProvider>
    </div>
  );
};

export default ImprovedShopPage;
